<template>
	<div id="CloseIcon">
          <i class="el-icon-close CloseIcon" @click="goBakc"></i>
	</div>
</template>

<script>
	export default {
		name: 'CloseIcon',
		data() {
			return {
				
			}
		},
		methods: {
			goBakc: function() {
				 this.$router.go(-1);
			}
		}
	}
</script>

<style scoped>
	.CloseIcon{
	    position: absolute;
		right: 10px;
		top:10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/CloseIcon.vue